import $ from "jquery";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { callGetApi, callPostApi } from "../api/ApiCaller.js";
import { GET_GAME_PLAY_RESULT_POST, GET_PLAYER_BALANCE_GET, GET_TEMPLATE_DETAILS_GET, RESET_BALANCE_AMT_POST, ADD_BALANCE_AMT_POST } from "../api/ApiConst.js";
import { CURRENCY_CODE, getAudioVolume, getDataFromStore, setAudioVolume, TEMPLATE_ID } from "../utils/CookiesUtils.js";
import { getFormattedAmount, getFormattedAmountN, getFormattedAmountWithDenomination, getFormattedAmountWithDenominationGamePlay, getFormattedAmountWithDenominationGamePlayBy100, isEmpty } from "../utils/TextUtils.jsx";
import ModalHalloween from "./common/ModalHalloween.jsx";
import LineImages from "./LineImages.jsx";
import NumberLineImages from "./NumberLineImages.jsx";
import HalloweenMachine from "./HalloweenMachine.jsx";
import Bonus01Strawberry from "./bonus/Bonus01Strawberry.jsx";
import RouletteBonus from "./bonus/RouletteBonus.jsx";
import CauldronBonus from "./bonus/CauldronBonus.jsx";
import DiceBonus from "./bonus/DIceBonus.jsx";
import PoolSpinBonus from "./bonus/PoolSpinBonus.jsx";
import GiraLuzBonus from "./bonus/GiraLuzBonus.jsx";
import PumpkinBonus from "./bonus/PumpkinBonus.jsx";
import CoinContainer from "./CoinContainer.jsx";
import { useNavigate } from "react-router-dom";
import BombaBunus from "./bonus/BombaBunus.jsx";
import BombaStrawberries from "./bonus/BombaStrawberries.jsx";
import BonusMaior from "./bonus/BonusMaior.jsx";


const GamePlayBomba = () => {
    const machineRef = useRef(null);

    const templateId = getDataFromStore(TEMPLATE_ID);
    const [templateData, setTemplateData] = useState(null);
    const [templateNumber, setTemplateNumber] = useState(20);
    const [walletBalance, setWalletBalance] = useState(0);

    const [gameResult, setGameResult] = useState(null);
    const [winnings, setWinnings] = useState(0);
    const [stopMachineFlag, setStopMachineFlag] = useState(false);
    const [showInsufficientFundModel, setShowInsufficientFundModel] = useState(false);
    const [showAutoNumberPickerModel, setShowAutoNumberPickerModel] = useState(false);
    const [showSettingModel, setShowSettingModel] = useState(false);
    const [ruleImagesArray, setRuleImagesArray] = useState([]);
    const [activeLineNumber, setActiveLineNumber] = useState(null);
    const [showHelpModel, setShowHelpModel] = useState(false);
    const [selectedNumber, setSelectedNumber] = useState(1);
    const [slotRunning, setSlotRunning] = useState(false);
    const [denomination, setDenomination] = useState(0.01);
    const [betMultiplier, setBetMultiplier] = useState(null);
    const [accumuladoList, setAccumuladoList] = useState([])

    const [pagoWinningCounter, setPagoWinningCounter] = useState(null);
    const [animateColumn, setAnimateColumn] = useState([false, false, false, false, false]);
    const [autoBetOn, setAutoBetOn] = useState(false);
    const [autoCount, setAutoCount] = useState(0);
    const [playMachine, setPlayMachine] = useState(0);
    const [showCoins, setShowCoins] = useState(false);

    // TO Disable > Ajuda / Auto / Apostar Buttons ( if true )
    const [buttonFlag, setButtonFlag] = useState(false);
    // TO Disable > Jogar Button ( if true )
    const [jogarButtonFlag, setJogarButtonFlag] = useState(false);

    const [showBonusModel, setShowBonusModel] = useState(false);
    const [showAjudaModel, setShowAjudaModel] = useState(false);
    const [showBonusBombaModel, setShowBonusBombaModel] = useState(false);
    const [accumuladoWin, setAccumuladoWin] = useState({ winAmount: 0, winIndex: -1 });
    const [bonusWinnings, setBonusWinnings] = useState(0);
    const [keyboardInput, setKeyboardInput] = useState(false);
    const [resetAmntModel, setResetAmntModel] = useState(false);
    const navigate = useNavigate();

    let currency = getDataFromStore(CURRENCY_CODE);
    useEffect(() => {
        getWalletBalance();
        getTemplateData();
    }, [templateId]);

    useEffect(() => {
        if (autoCount > 0 || autoCount === -1) {
            placeBet();
        } else {
            setAutoBetOn(false);
            setAutoCount(0);
        }
    }, [playMachine]);

    const getWalletBalance = () => {
        callGetApi(GET_PLAYER_BALANCE_GET, {}, (response) => {
            if (response.errorCode === 0) {
                const balance = Math.round(response.responsePacket * 100.0) / 100.0;
                setWalletBalance(balance);
                // window._setWalletBalanceAnimate(res / denomination);
            }
        });
    };

    const getTemplateData = () => {
        if (!templateId) { return; }
        callGetApi(GET_TEMPLATE_DETAILS_GET.replaceAll("{recordId}", templateId), {}, (response) => {
            if (response.errorCode === 0) {
                const res = response.responsePacket;
                setKeyboardInput(response.responsePacket.keyboardInput)
                let accList = res?.accumuladoList
                let updatedAccList = accList.map(item => ({
                    ...item,
                    accumuladoActual: Math.round(item.accumuladoActual / denomination)
                }));
                setAccumuladoList(updatedAccList);
                setTemplateData(res);
                setBetMultiplier(res.betAmountList[0]);
                if (res) {
                    if (res.slotGameType === "Halloween_20") {
                        setTemplateNumber(20);
                        setRuleImagesArray(["assets/img/rules1_20.png", "assets/img/rules2_20.png"]);
                    } else if (res.slotGameType === "Halloween_25") {
                        setTemplateNumber(25);
                        setRuleImagesArray(["assets/img/rules1_25.png", "assets/img/rules2_25.png", "assets/img/rules3_25.png"]);
                    } else if (res.slotGameType === "Halloween_30") {
                        setTemplateNumber(30);
                        setRuleImagesArray(["assets/img/rules1_30.png", "assets/img/rules2_30.png", "assets/img/rules3_30.png"]);
                    }
                }
            }
        });
    }

    const [animationTimeOutRef, setAnimationTimeOutRef] = useState([]);
    const [autoBetTimeOutRef, setAutoBetTimeOutRef] = useState(null);
    const [animationIntervalRef, setAnimationIntervalRef] = useState([]);

    const stopAllAnimation = () => {
        $("#SlotMp3")[0].pause();
        $("#SlotMp3")[0].currentTime = 0;
        setAnimateColumn([false, false, false, false, false]);
        setSlotRunning(false);
        animationTimeOutRef.map((animateRef) => {
            clearTimeout(animateRef);
        });
        animationIntervalRef.map((animateRef) => {
            clearInterval(animateRef);
        });
        setStopMachineFlag(true);
        drawWinningLineOnResult(gameResult);

        $("#CreditsCounterMp3")[0].pause();
        $("#CreditsCounterMp3")[0].currentTime = 0;
        setWinnings(0);

        // if (gameResult.winnings > 0) {
        //     setPagoWinningCounter(gameResult.winnings);
        // }
        // setWalletBalance((previousBalance) => previousBalance + (gameResult.winnings * denomination));
        // setButtonFlag(false);
        let lastBalance = walletBalance;
        let gameWinn = gameResult.winnings + accumuladoWin.winAmount
        if (gameResult.winnings > 0 || accumuladoWin.winAmount > 0) {
            setButtonFlag(true);
            setWinnings(gameResult.winnings);
            // if (gameResult.bonusType === "None" || accumuladoWin.winAmount > 0 ) { 
            if (gameResult.bonusType === "None") {
                if (accumuladoWin.winAmount > 0) {
                    setShowCoins(true)
                    setTimeout(() => {
                        setShowCoins(false)
                        animateAccumuladoWinning(lastBalance, accumuladoWin.winAmount, accumuladoWin.winIndex);
                        playWinningAnimation(lastBalance, gameResult.winnings, accumuladoWin.winAmount);
                    }, 25000);
                }
                else {
                    playWinningAnimation(lastBalance, gameResult.winnings, accumuladoWin.winAmount);
                }
            }
        }
        if (gameResult.bonusType !== "None") {
            openBonusModel();
            // bonusWinningAddAnimation(gameResult?.winnings)
        } else {
            setButtonFlag(false);
        }
    };

    const openBonusModel = () => {
        // handleBonusType
        setTimeout(() => {
            setShowBonusModel(true);
        }, 2000);
    }



    const placeBet = () => {
        if (jogarButtonFlag) { return }
        setPagoWinningCounter(null);
        setShowAutoNumberPickerModel(false);
        $(".line-show").removeClass(" active");
        $(".number-show").removeClass("animate-blink");
        for (let i = 1; i <= selectedNumber; i++) {
            const imgDiv = document.getElementsByClassName(`line-show${i}`);
            if (imgDiv[0]) {
                imgDiv[0].classList.add("active1");
            }
        }
        let totalBetAmount = betMultiplier * selectedNumber;
        if (walletBalance < totalBetAmount) {
            playSoundById("ErrorMp3");
            setShowInsufficientFundModel(true);
            setTimeout(() => {
                setShowInsufficientFundModel(false);
            }, 3000);
            setAutoBetOn(false);
            setAutoCount(0);
            return;
        }
        if (autoBetTimeOutRef !== null) {
            clearTimeout(autoBetTimeOutRef);
        }
        // playSound("assets/slot.mp3");
        playSoundById("SlotMp3");
        setButtonFlag(true);
        setJogarButtonFlag(true);
        setSlotRunning(true);
        setStopMachineFlag(false);
        let pAnimateColumn = [true, true, true, true, true];
        setAnimateColumn(pAnimateColumn);
        machineRef.current.spin();

        let totalBetCount = getFormattedAmountWithDenomination(totalBetAmount, denomination);
        let payload = {
            slotLineType: `Line_${selectedNumber}`,
            betAmount: totalBetCount
        };
        let lastBalance = walletBalance;
        let balance = Math.round((lastBalance - totalBetAmount) * 100) / 100.0;
        setWalletBalance(balance);
        var pAnimationTimeOutRef = [];
        var pAutoBetTimeOutRef = null;

        callPostApi(GET_GAME_PLAY_RESULT_POST.replaceAll("{templateId}", templateId), payload, {}, (response) => {
            setJogarButtonFlag(false);
            if (response.errorCode === 0) {
                let gameResult = response.responsePacket;
                let updatedAccumulado = response?.responsePacket?.accumuladoList;
                let accumuladoWinningAmt = response?.responsePacket?.accumuladoActual;
                setKeyboardInput(gameResult.keyboardInput)

                setGameResult(gameResult);
                let winningIndex;

                const fixAccumuladoList = (list) => {
                    if (!Array.isArray(list) || list.length === 0) return [];
                    let updatedList = list.map(item => ({
                        ...item,
                        accumuladoActual: Math.round(item.accumuladoActual / denomination)
                    }));
                    winningIndex = updatedList.findIndex(item => item.accumuladoActual === 0);
                    if (winningIndex !== -1 && accumuladoWinningAmt > 0) {
                        updatedList[winningIndex].accumuladoActual = Math.round(accumuladoWinningAmt / denomination);
                        setAccumuladoWin({
                            winAmount: Math.round(accumuladoWinningAmt / denomination),
                            winIndex: winningIndex
                        });
                    }
                    else {
                        setAccumuladoWin({ winAmount: 0, winIndex: -1 });
                    }

                    return updatedList;
                };
                const newAccumuladoList = fixAccumuladoList(updatedAccumulado);
                setAccumuladoList(newAccumuladoList);

                pAnimationTimeOutRef.push(setTimeout(() => {
                    setAnimateColumn((pre) => ({ ...pre, [0]: false }));
                }, 1500));
                pAnimationTimeOutRef.push(setTimeout(() => {
                    setAnimateColumn((pre) => ({ ...pre, [1]: false }));
                }, 2000));
                pAnimationTimeOutRef.push(setTimeout(() => {
                    setAnimateColumn((pre) => ({ ...pre, [2]: false }));
                }, 2500));
                pAnimationTimeOutRef.push(setTimeout(() => {
                    setAnimateColumn((pre) => ({ ...pre, [3]: false }));
                }, 3000));
                pAnimationTimeOutRef.push(setTimeout(() => {
                    setAnimateColumn((pre) => ({ ...pre, [4]: false }));
                    drawWinningLineOnResult(gameResult);
                    if (gameResult.bonusType === "None") {
                        let roundAccWin = Math.round(accumuladoWinningAmt / denomination);
                        let winningAmountAdd = gameResult.winnings + roundAccWin
                        if (accumuladoWinningAmt > 0) {
                            setShowCoins(true)
                            setTimeout(() => {
                                setShowCoins(false);
                                animateAccumuladoWinning(walletBalance, roundAccWin, winningIndex);
                                playWinningAnimation(walletBalance, gameResult.winnings, roundAccWin);
                            }, 25000);
                        }
                        else {
                            playWinningAnimation(walletBalance, gameResult.winnings, roundAccWin);
                        }
                    }
                    else {
                        openBonusModel();
                    }
                }, 3500));

                pAnimationTimeOutRef.push(setTimeout(() => {
                    setSlotRunning(false);
                    // setButtonFlag(false);
                    if (gameResult.winnings > 0) {
                        setButtonFlag(true);
                    } else {
                        setButtonFlag(false);
                    }
                }, 4000));
                let autoTimer = 7500;
                if (gameResult?.winnings <= 0) {
                    autoTimer = 4000;
                }
                if (accumuladoWinningAmt > 0) {
                    autoTimer = 38500;
                }
                if (autoBetOn && gameResult.bonusType === "None") {
                    pAutoBetTimeOutRef = setTimeout(() => {
                        setAutoCount(prevCount => {
                            if (prevCount > 0) {
                                return prevCount - 1;
                            } else if (prevCount === 0) {
                                return 0;
                            } else {
                                return -1;
                            }
                        });
                        setPlayMachine(pCounter => pCounter + 1);
                    }, autoTimer);
                    setAutoBetTimeOutRef(pAutoBetTimeOutRef);
                    pAnimationTimeOutRef.push(pAutoBetTimeOutRef);
                }
                setAnimationTimeOutRef(pAnimationTimeOutRef);
            } else if (response.errorCode === 1001) {
                toast.error(response.message);
                window.location.reload();
            } else {
                setButtonFlag(false);
                setJogarButtonFlag(false);
                toast.error(response.message);
                let balance = Math.round((lastBalance) * 100) / 100.0;
                setWalletBalance(balance);
                setAnimateColumn([false, false, false, false, false]);
            }
        }, (error) => {
            setButtonFlag(false);
            setJogarButtonFlag(false);
            toast.error(error);
            let balance = Math.round((lastBalance) * 100) / 100.0;
            setWalletBalance(balance);
            setAnimateColumn([false, false, false, false, false]);
        });
    }

    const drawWinningLineOnResult = (pGameResult) => {
        if (!pGameResult || !Array.isArray(pGameResult.payLines) || !pGameResult.winnings) {
            return;
        }
        setJogarButtonFlag(true)
        if (pGameResult.winnings > 0) {
            setWinnings(pGameResult.winnings);
        }
        if (pGameResult.payLines.length > 0) {
            playSoundById("Win45Wav");
        }
        pGameResult.payLines.forEach((item) => {
            $(".line-show").removeClass("active1");
            let imgDiv = document.getElementsByClassName(item.title);
            if (imgDiv[0]) {
                imgDiv[0].classList.add("active");
            }
            let numberDiv = document.getElementsByClassName(`number-show${item.title.replace("line-show", "")}`);
            if (numberDiv[0]) {
                numberDiv[0].classList.add("animate-blink");
            }
        });
    };

    const animateAccumuladoWinning = (currentBalance, winnings, accIndex) => {
        setShowCoins(false);
        if (!winnings || winnings <= 0) return;
        let timeFactor = Math.min(Math.max(5000 / winnings, 2), 20);
        if (timeFactor * winnings < 2000) {
            timeFactor = Math.ceil(2000 / winnings);
        }
        const decrementFactor = Math.max(1, Math.ceil((winnings * timeFactor) / 500));
        let currentWinnings = winnings;
        setTimeout(() => {
            const intervalId = setInterval(() => {
                if (currentWinnings > 0) {
                    currentWinnings -= decrementFactor;
                    setAccumuladoList((prevList) => {
                        if (!Array.isArray(prevList)) return prevList;
                        const updatedList = [...prevList];
                        if (updatedList[accIndex]) {
                            updatedList[accIndex] = {
                                ...updatedList[accIndex],
                                accumuladoActual: Math.max(0, currentWinnings),
                            };
                        }
                        return updatedList;
                    });
                } else {
                    clearInterval(intervalId);
                }
            }, timeFactor);
        }, 1600);
    };

    const playWinningAnimation = (currentBalance, winnings, accumWin) => {
        const totalWin = winnings + accumWin;
        if (totalWin <= 0) return;
        let timeFactor = Math.min(Math.max(5000 / totalWin, 2), 20);
        if (timeFactor * totalWin < 2000) {
            timeFactor = Math.ceil(2000 / totalWin);
        }
        const incrementFactor = Math.max(1, Math.floor((totalWin * timeFactor) / 500));
        const pAnimationTimeOutRef = [...animationTimeOutRef];
        const audioElement = $("#CreditsCounterMp3")[0];
        const playAudio = () => {
            if (!audioElement) return;
            audioElement.volume = accumWin > 0 ? 0.5 : 1.0;
            audioElement.loop = true;
            audioElement.play().catch(err => console.error("Audio Play Error:", err));
        };
        const stopAudio = () => {
            if (!audioElement) return;
            audioElement.pause();
            audioElement.currentTime = 0;
        };
        const finalizeAnimation = () => {
            setWinnings(0);
            setPagoWinningCounter(totalWin);
            setWalletBalance(currentBalance + (totalWin * denomination));
            stopAudio();
            setButtonFlag(false);
            setJogarButtonFlag(false);
        };
        const startPhase2 = (startFrom = totalWin) => {
            playAudio();
            let current = startFrom;
            const interval = setInterval(() => {
                if (current <= 0) {
                    clearInterval(interval);
                    finalizeAnimation();
                    return;
                }
                const step = Math.min(incrementFactor, current);
                current -= step;
                setWinnings(current);
                setPagoWinningCounter(totalWin - current);
                setWalletBalance(prev => prev + (step * denomination));
            }, timeFactor);
            setAnimationIntervalRef([interval]);
        };
        const startPhase1 = () => {
            playAudio();
            let current = winnings;
            setWinnings(current);
            const interval = setInterval(() => {
                current += incrementFactor;
                if (current >= totalWin) {
                    clearInterval(interval);
                    setWinnings(totalWin);
                    stopAudio();
                    setTimeout(() => startPhase2(totalWin), 2000);
                } else {
                    setWinnings(current);
                }
            }, timeFactor);
            setAnimationIntervalRef([interval]);
        };
        setButtonFlag(true);
        setJogarButtonFlag(true);
        if (accumWin > 0) {
            pAnimationTimeOutRef.push(setTimeout(startPhase1, 1700));
        } else {
            pAnimationTimeOutRef.push(setTimeout(() => startPhase2(winnings), 1700));
        }
        setAnimationTimeOutRef(pAnimationTimeOutRef);
    };
    const playSoundById = (soundTagId) => {
        $("#" + soundTagId)[0].play();
    };

    const setSoundLevelOfAudio = (level) => {
        $(".audioFile").prop("volume", level);
    }

    const setNextSoundLevelOfAudio = () => {
        playSoundById("ButtonClickMp3");
        var audioVolume = getAudioVolume();
        if (audioVolume === 0) {
            audioVolume = 0.25;
        } else if (audioVolume === 0.25) {
            audioVolume = 0.50;
        } else if (audioVolume === 0.50) {
            audioVolume = 0.75;
        } else if (audioVolume === 0.75) {
            audioVolume = 1.0;
        } else if (audioVolume === 1.0) {
            audioVolume = 0;
        }
        setAudioVolume(audioVolume);
        setSoundLevelOfAudio(audioVolume);
        $("#audioVolume").prop("src", "/assets/img/sound/sound-" + audioVolume.toFixed(2) + ".png");
    }

    window._setSoundLevelOfAudio = (level) => {
        setSoundLevelOfAudio(level);
    }

    const updateAutoCount = (pCount) => {
        setAutoCount(pCount);
        if (pCount === 0) {
            setAutoBetOn(false);
        }
        setAutoBetOn(true);
        setShowAutoNumberPickerModel(false);
        if (!slotRunning) {
            setPlayMachine(pCounter => pCounter + 1);
        }
    };

    const stopAnimation = (e, lineNumber) => {
        let pAnimateColumn = animateColumn;
        if (lineNumber === 1) {
            pAnimateColumn[0] = false;
        } else if (lineNumber === 5) {
            pAnimateColumn[1] = false;
        } else if (lineNumber === 9) {
            pAnimateColumn[2] = false;
        } else if (lineNumber === 15) {
            pAnimateColumn[3] = false;
        } else if (lineNumber === 20 || lineNumber === 25 || lineNumber === 30) {
            pAnimateColumn[4] = false;
        }
        setAnimateColumn((pre) => ({
            ...pre,
            pAnimateColumn
        }));
    };

    const drawLine = (number) => {
        playSoundById("AwardWav");
        setSelectedNumber(number);
        setActiveLineNumber(number);
        $(".line-show").removeClass("active");
        $(".number-show").removeClass("active");
        $(".line-show").removeClass("active1");
        Array.from({ length: number }, (_, index) => {
            let imgLine = document.getElementsByClassName(`line-show${index + 1}`);
            let imgNumber = document.getElementsByClassName(`number-show${index + 1}`);
            if (imgLine[0]) {
                imgLine[0].classList.add("active");
            }
            if (imgNumber[0]) {
                imgNumber[0].classList.add("active");
            }
        });
        let wheelBoxes = document.querySelectorAll(".wheelBox");
        wheelBoxes.forEach((wheelBox) => {
            wheelBox.classList.remove("matchbox");
        });
        let animateBlink = document.querySelectorAll(".animate-blink");
        animateBlink.forEach((wheelBox) => {
            wheelBox.classList.remove("animate-blink");
        });
    };

    const increaseBetMultiplier = () => {
        playSoundById("AwardWav");
        setBetMultiplier((prevMultiplier) => {
            const currentIndex = templateData.betAmountList.findIndex((bet) => bet === prevMultiplier);
            if (currentIndex === -1) {
                return templateData.betAmountList[0];
            }

            const nextIndex = (currentIndex + 1) % templateData.betAmountList.length;
            return templateData.betAmountList[nextIndex];
        });
    };


    const [helpSwiperInstance, setHelpSwiperInstance] = useState(null);
    const [currentIndexOfHelpSlide, setCurrentIndexOfHelpSlide] = useState(0);
    const handlePreviousHelpSlide = () => {
        if (currentIndexOfHelpSlide > 0) {
            playSoundById("ButtonClickMp3");
            const prevIndex = currentIndexOfHelpSlide - 1;
            helpSwiperInstance.slideTo(prevIndex);
            setCurrentIndexOfHelpSlide(prevIndex);
        }
    };
    const handleNextHelpSlide = () => {
        if (currentIndexOfHelpSlide < ruleImagesArray.length - 1) {
            playSoundById("ButtonClickMp3");
            const nextIndex = currentIndexOfHelpSlide + 1;
            helpSwiperInstance.slideTo(nextIndex);
            setCurrentIndexOfHelpSlide(nextIndex);
        }
    };
    function formatAmount(amount) {
        let formatter;
        try {
            formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: currency,
                minimumFractionDigits: 2,
            });
        } catch (e) {
            console.warn(`Invalid currency code "${currency}", defaulting to USD.`);
            formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
            });
        }
        return formatter.format(amount).replace(/(\D)(\d)/, '$1 $2');
    }



    const addBalance = () => {
        callPostApi(ADD_BALANCE_AMT_POST, {}, {}, (resp) => {
            if (resp.errorCode === 0) {
                setWalletBalance(resp.responsePacket)
                // navigate(0)
            }
        })
    }
    const resetBalance = () => {
        callPostApi(RESET_BALANCE_AMT_POST, {}, {}, (resp) => {
            if (resp.errorCode === 0) {
                setWalletBalance(resp.responsePacket)
            }
        })
    }


    useEffect(() => {
        const handleKeyPress = (event) => {
            const key = event.key.toLowerCase();
            const disabled = jogarButtonFlag || buttonFlag;

            if (key === "t") {
                if (!disabled) {
                    playSoundById("ButtonClickMp3");

                    if (!showHelpModel) {
                        setShowHelpModel(true);
                        setCurrentIndexOfHelpSlide(0);

                        setTimeout(() => {
                            if (helpSwiperInstance) {
                                helpSwiperInstance.slideTo(0);
                            }
                        }, 100);
                    } else {
                        if (currentIndexOfHelpSlide < ruleImagesArray.length - 1) {
                            const nextIndex = currentIndexOfHelpSlide + 1;
                            helpSwiperInstance?.slideTo(nextIndex);
                            setCurrentIndexOfHelpSlide(nextIndex);
                        } else {
                            setShowHelpModel(false);
                        }
                    }
                }
            } else if (key === "y") {
                document.getElementById("line-btn-1")?.click();
            } else if (key === "j") {
                document.getElementById("line-btn-5")?.click();
            } else if (key === "h") {
                document.getElementById("line-btn-9")?.click();
            } else if (key === "m") {
                document.getElementById("line-btn-15")?.click();
            } else if (key === "n") {
                if (templateNumber === 20) document.getElementById("line-btn-20")?.click();
                else if (templateNumber === 25) document.getElementById("line-btn-25")?.click();
                else if (templateNumber === 30) document.getElementById("line-btn-30")?.click();
            } else if (key === "g" && !jogarButtonFlag && !buttonFlag) {
                increaseBetMultiplier();
            } else if (key === "p" && !jogarButtonFlag && !buttonFlag) {
                addBalance();
            } else if (key === "r" && !jogarButtonFlag && !buttonFlag && walletBalance > 0) {
                if (!resetAmntModel) {
                    setResetAmntModel(true);
                } else {
                    setResetAmntModel(false);
                    resetBalance();
                }
            } else if (key === "v" && !jogarButtonFlag && !buttonFlag) {
                if (!autoBetOn) {
                    setAutoBetOn(true);
                    setAutoCount(-1);
                } else {
                    setAutoBetOn(false);
                    setAutoCount(0);
                }
                setPlayMachine((p) => p + 1);
            } else if (key === "b" && !jogarButtonFlag) {
                setAutoBetOn(false);
                setAutoCount(0);
                if (slotRunning) {
                    stopAllAnimation();
                } else {
                    placeBet();
                }
            }
        };
        if (showBonusModel) {
            window.removeEventListener("keydown", handleKeyPress);
        }
        else if (keyboardInput) {
            window.addEventListener("keydown", handleKeyPress);
            return () => {
                window.removeEventListener("keydown", handleKeyPress);
            };
        }
    }, [jogarButtonFlag, showBonusModel, walletBalance, selectedNumber, betMultiplier, resetAmntModel, buttonFlag, autoBetOn, templateNumber, slotRunning, showHelpModel, currentIndexOfHelpSlide, helpSwiperInstance, ruleImagesArray.length]);



    const getBottomPrizeSection = () => {
        return <>

            <div className="d-flex align-items-end justify-content-between future-price position-relative z-1 gap-2">
                <div className="d-block position-relative custom-w20">
                    <div className=" position-relative ">
                        <img className="btnImg" src="assets/img/btn-bg.png" alt="" />
                        <span className="btn-content">{formatAmount(accumuladoList[1]?.accumuladoActual / 100)}</span>
                    </div>
                    <div className="d-flex align-items-center justify-content-center" style={{ marginTop: "-20px" }}>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                    </div>
                </div>
                <div className="d-flex align-items-end justify-content-center">
                    <div className="w-auto text-center bomba-img-height">
                        <img className="img-fluid w-100 h-100 " src="assets/img/logo-bomba.png" alt="" />
                    </div>
                    <div className="w-auto text-center">
                        <span className="d-flex align-items-center justify-content-center position-relative mx-auto bomba-img-height">
                            <img className="img-fluid w-100 h-100" src="assets/img/bomba-img.png" alt="" />
                            <img className="img-fluid position-absolute top-0 end-0 spin-animation" src="assets/img/pavio-img.png" alt="" />
                        </span>
                    </div>
                </div>
                <div className="d-block position-relative custom-w20">
                    <div className=" position-relative ">
                        <img className="btnImg" src="assets/img/btn-bg.png" alt="" />
                        <span className="btn-content">{formatAmount(accumuladoList[2]?.accumuladoActual / 100)}</span>
                    </div>
                    <div className="d-flex align-items-center justify-content-center" style={{ marginTop: "-20px" }}>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                    </div>
                </div>
            </div>
            {/* {templateNumber === 20 && (
                <div className="d-flex align-items-center justify-content-end future-price p-0">
                    <div className="position-relative custom-w20 me-3 img20">
                        <img className="btnImg" src="assets/img/btn-bg4x.png" alt="" />
                        <span className="btn-content">{formatAmount(accumuladoList[0]?.accumuladoActual / 100)}</span>
                    </div>
                    <div className="position-relative custom-w20 img20">
                        <img className="btnImg" src="assets/img/btn-bg5x.png" alt="" />
                        <span className="btn-content">{formatAmount(accumuladoList[1]?.accumuladoActual / 100)}</span>
                    </div>
                </div>
            )}
            {templateNumber === 25 && (
                <div className="d-flex align-items-center justify-content-between future-price position-relative z-1 gap-2">
                    <div className="d-block position-relative custom-w20">
                        <div className=" position-relative ">
                            <img className="btnImg" src="assets/img/btn-bg.png" alt="" />
                            <span className="btn-content">{formatAmount(accumuladoList[0]?.accumuladoActual / 100)}</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-center" style={{ marginTop: "-20px" }}>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/magicaIcon.png" className="img-fluid" alt="magicaIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/magicaIcon.png" className="img-fluid" alt="magicaIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/magicaIcon.png" className="img-fluid" alt="magicaIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/magicaIcon.png" className="img-fluid" alt="magicaIcon" /></div>
                        </div>
                    </div>
                    <div className="d-block position-relative custom-w20">
                        <div className=" position-relative ">
                            <img className="btnImg" src="assets/img/btn-bg.png" alt="" />
                            <span className="btn-content">{formatAmount(accumuladoList[1]?.accumuladoActual / 100)}</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-center" style={{ marginTop: "-20px" }}>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                        </div>
                    </div>
                    <div className="d-block position-relative custom-w20">
                        <div className=" position-relative ">
                            <img className="btnImg" src="assets/img/btn-bg.png" alt="" />
                            <span className="btn-content">{formatAmount(accumuladoList[2]?.accumuladoActual / 100)}</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-center" style={{ marginTop: "-20px" }}>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                        </div>
                    </div>
                </div>
            )}
            {templateNumber === 30 && (
                <div className="d-flex align-items-center justify-content-between future-price position-relative z-1 gap-2">
                    <div className="d-block position-relative custom-w20">
                        <div className=" position-relative ">
                            <img className="btnImg" src="assets/img/btn-bg.png" alt="" />
                            <span className="btn-content">{formatAmount(accumuladoList[0]?.accumuladoActual / 100)}</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-center" style={{ marginTop: "-20px" }}>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/magicaIcon.png" className="img-fluid" alt="magicaIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/magicaIcon.png" className="img-fluid" alt="magicaIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/magicaIcon.png" className="img-fluid" alt="magicaIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/magicaIcon.png" className="img-fluid" alt="magicaIcon" /></div>
                        </div>
                        <span className="dice-position position-absolute z-0"><img src="assets/img/dice.png" alt="cross" className="img-fluid" /></span>
                    </div>
                    <div className="d-block position-relative custom-w20">
                        <div className="text-hallo text-white">Hallo Ex II</div>
                        <div className=" position-relative ">
                            <img className="btnImg" src="assets/img/btn-bg.png" alt="" />
                            <span className="btn-content">{formatAmount(accumuladoList[1]?.accumuladoActual / 100)}</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-center" style={{ marginTop: "-20px" }}>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                        </div>
                    </div>
                    <div className="d-block position-relative custom-w20">
                        <div className="text-linha text-white">30 Linhas</div>
                        <div className=" position-relative ">
                            <img className="btnImg" src="assets/img/btn-bg.png" alt="" />
                            <span className="btn-content">{formatAmount(accumuladoList[2]?.accumuladoActual / 100)}</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-center" style={{ marginTop: "-20px" }}>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                        </div>
                    </div>
                    <div className="d-block position-relative custom-w20">
                        <div className=" position-relative ">
                            <img className="btnImg" src="assets/img/btn-bg.png" alt="" />
                            <span className="btn-content">{formatAmount(accumuladoList[3]?.accumuladoActual / 100)}</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-center" style={{ marginTop: "-20px" }}>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                            <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                        </div>
                    </div>
                    <div className="roleta-pos position-absolute"><img src="assets/img/roleta.png" alt="cross" className="img-fluid" /></div>
                </div>
            )} */}
        </>
    }
    const getLineButton = (lineCount, key) => {
        return <button id={key} className={`btn-footer d-flex align-items-center justify-content-center position-relative ${selectedNumber === lineCount ? "btn-line-active" : ""}`}
            onClick={(e) => {
                if (slotRunning) {
                    stopAnimation(e, lineCount);
                } else {
                    drawLine(lineCount);
                }
            }} >
            <span className="btn-footer-inner">Linha {lineCount}</span>
        </button>
    }
    const getLineBombaButton = (lineCount, key) => {
        return <span id={key} className={`position-relative ${selectedNumber === lineCount ? "btn-line-active" : ""}`}
            onClick={(e) => {
                if (slotRunning) {
                    stopAnimation(e, lineCount);
                } else {
                    drawLine(lineCount);
                }
            }} >
            <img className="img-fluid" src="assets/img/yellow-btn-img.png" alt="" />
            <span className="btn-yellow position-absolute top-0 end-0 bottom-0 start-0">
                <span className="btn-name">Linha</span>
                <span className="btn-number">{lineCount}</span>
            </span>
        </span>
    }
    const getFooterLineButtonSection = () => {
        return <>
            <div className="button-linha">
                <button
                    onMouseDown={(e) => e.currentTarget.classList.add('btn-line-active')}
                    onMouseUp={(e) => e.currentTarget.classList.remove('btn-line-active')}
                    onMouseLeave={(e) => e.currentTarget.classList.remove('btn-line-active')}
                    className="btn-footer d-flex align-items-center justify-content-center"
                    disabled={jogarButtonFlag || buttonFlag}>
                    <span className="btn-footer-inner" onClick={() => {
                        playSoundById("ButtonClickMp3");
                        setShowHelpModel(true);
                    }}>Ajuda</span>
                </button>
                {getLineButton(1, "line-btn-1")}
                {getLineButton(5, "line-btn-5")}
                {getLineButton(9, "line-btn-9")}
                {getLineButton(15, "line-btn-15")}
                {templateNumber === 20 && getLineButton(20, "line-btn-20")}
                {templateNumber === 25 && getLineButton(25, "line-btn-25")}
                {templateNumber === 30 && getLineButton(30, "line-btn-30")}
                <button
                    onMouseDown={(e) => e.currentTarget.classList.add('btn-line-active')}
                    onMouseUp={(e) => e.currentTarget.classList.remove('btn-line-active')}
                    onMouseLeave={(e) => e.currentTarget.classList.remove('btn-line-active')}
                    className="btn-footer d-flex align-items-center justify-content-center"
                    onClick={() => increaseBetMultiplier()} disabled={jogarButtonFlag || buttonFlag}>
                    <span className="btn-footer-inner">Apostar</span>
                </button>
                <button className={`btn-footer d-flex align-items-center justify-content-center ${autoBetOn ? "btn-line-active" : ""}`}
                    onClick={() => {
                        if (!autoBetOn) {
                            setAutoBetOn(true);
                            setAutoCount(-1);
                        } else {
                            setAutoBetOn(false);
                            setAutoCount(0);
                        }
                        setPlayMachine(pCounter => pCounter + 1);
                    }} disabled={jogarButtonFlag || buttonFlag}>
                    <span className="btn-footer-inner">Auto</span>
                </button>
                <button
                    onMouseDown={(e) => e.currentTarget.classList.add('btn-line-active')}
                    onMouseUp={(e) => e.currentTarget.classList.remove('btn-line-active')}
                    onMouseLeave={(e) => e.currentTarget.classList.remove('btn-line-active')}
                    className={`btn-footer d-flex align-items-center justify-content-center ${jogarButtonFlag ? "btn-line-active" : ""}`}
                    onClick={(e) => {
                        setAutoBetOn(false);
                        setAutoCount(0);
                        if (slotRunning) {
                            stopAllAnimation();
                        } else {
                            placeBet();
                        }
                    }} disabled={jogarButtonFlag}>
                    <span className="btn-footer-inner">Jogar</span>
                </button>
            </div>
        </>
    }
    const getFooterBombaLineButtonSection = () => {
        return <div className="d-flex bomba-footer align-items-center justify-content-between w-100">
            <span className="position-relative">
                <img className="img-fluid" src="assets/img/red-btn-img.png" alt="" />
                <span className="btn-red position-absolute top-0 end-0 bottom-0 start-0">
                    <span className="btn-name">Menu</span>
                </span>
            </span>
            {getLineBombaButton(1, "line-btn-1")}
            {getLineBombaButton(5, "line-btn-5")}
            {getLineBombaButton(9, "line-btn-9")}
            {getLineBombaButton(15, "line-btn-15")}
            {getLineBombaButton(25, "line-btn-25")}
            <span className={`position-relative ${autoBetOn ? "btn-line-active" : ""}`}
                onClick={() => {
                    if (!autoBetOn) {
                        setAutoBetOn(true);
                        setAutoCount(-1);
                    } else {
                        setAutoBetOn(false);
                        setAutoCount(0);
                    }
                    setPlayMachine(pCounter => pCounter + 1);
                }} disabled={jogarButtonFlag}>
                <img className="img-fluid" src="assets/img/auto-btn-img.png" alt="" />
                <span className="btn-yellow position-absolute top-0 end-0 bottom-0 start-0">
                    <span className="btn-name">Auto</span>
                </span>
            </span>
            <span onClick={() => {
                playSoundById("ButtonClickMp3");
                setShowAjudaModel(true);
            }}
                onMouseDown={(e) => e.currentTarget.classList.add('btn-line-active')}
                onMouseUp={(e) => e.currentTarget.classList.remove('btn-line-active')}
                onMouseLeave={(e) => e.currentTarget.classList.remove('btn-line-active')}
                className="position-relative"
                disabled={jogarButtonFlag}>
                <img className="img-fluid" src="assets/img/blue-btn-img.png" alt="" />
                <span className="btn-yellow position-absolute top-0 end-0 bottom-0 start-0">
                    <span className="btn-name">Ajuda</span>
                </span>
            </span>
            <span
                onMouseDown={(e) => e.currentTarget.classList.add('btn-line-active')}
                onMouseUp={(e) => e.currentTarget.classList.remove('btn-line-active')}
                onMouseLeave={(e) => e.currentTarget.classList.remove('btn-line-active')}
                className="position-relative"
                onClick={() => increaseBetMultiplier()} disabled={jogarButtonFlag}>
                <img className="img-fluid" src="assets/img/aposta-btn-img.png" alt="" />
                <span className="btn-yellow position-absolute top-0 end-0 bottom-0 start-0">
                    <span className="btn-name">Aposta</span>
                    <span className="btn-name">Max</span>
                </span>
            </span>
            <span
                onMouseDown={(e) => e.currentTarget.classList.add('btn-line-active')}
                onMouseUp={(e) => e.currentTarget.classList.remove('btn-line-active')}
                onMouseLeave={(e) => e.currentTarget.classList.remove('btn-line-active')}
                className={`position-relative ${jogarButtonFlag ? "btn-line-active" : ""}`}
                onClick={(e) => {
                    setAutoBetOn(false);
                    setAutoCount(0);
                    if (slotRunning) {
                        stopAllAnimation();
                    } else {
                        placeBet();
                    }
                }} disabled={jogarButtonFlag}>
                <img className="img-fluid" src="assets/img/jogar-btn-img.png" alt="" />
                <span className="btn-red position-absolute top-0 end-0 bottom-0 start-0">
                    <span className="btn-name">Jogar</span>
                </span>
            </span>
        </div>
    }
    const getAutoButtonModel = () => {
        return !showAutoNumberPickerModel ? <></> : <div className="bottom-left-div">
            <div className="cursor-pointer w-100 d-flex align-items-center justify-content-center turn-btn px-2 py-1"
                onClick={handleCancelAutoBet}>DESLIGAR</div>
            <div className="auto-digits mt-2">
                <div className="row">
                    <div className="col-4">
                        <div className="digits d-flex align-items-center justify-content-center cursor-pointer"
                            onClick={() => updateAutoCount(10)}
                        >10</div>
                    </div>
                    <div className="col-4">
                        <div className="digits d-flex align-items-center justify-content-center cursor-pointer"
                            onClick={() => updateAutoCount(25)}
                        >25</div>
                    </div>
                    <div className="col-4">
                        <div className="digits d-flex align-items-center justify-content-center cursor-pointer"
                            onClick={() => updateAutoCount(50)}
                        >50</div>
                    </div>
                    <div className="col-4 mt-2">
                        <div className="digits d-flex align-items-center justify-content-center cursor-pointer"
                            onClick={() => updateAutoCount(100)}
                        >100</div>
                    </div>
                    <div className="col-4 mt-2">
                        <div className="digits d-flex align-items-center justify-content-center cursor-pointer"
                            onClick={() => updateAutoCount(250)}
                        >250</div>
                    </div>
                    <div className="col-4 mt-2">
                        <div className="digits d-flex align-items-center justify-content-center cursor-pointer"
                            onClick={() => updateAutoCount(-1)}
                        >∞</div>
                    </div>
                </div>
            </div>
        </div>
    }

    const toggleAutoButtonModel = () => {
        if (!buttonFlag) {
            playSoundById("ButtonClickMp3");
            setShowAutoNumberPickerModel(!showAutoNumberPickerModel);
        }
    };

    const handleCancelAutoBet = () => {
        playSoundById("ButtonClickMp3");
        setAutoCount(0);
        setAutoBetOn(false);
        setShowAutoNumberPickerModel(false);
    };

    const toggleSettingModel = () => {
        playSoundById("ButtonClickMp3");
        setShowSettingModel(!showSettingModel);
    };

    const [currentFlagIndex, setCurrentFlagIndex] = useState(0);
    const flagImg = ["assets/img/br.png", "assets/img/en.png", "assets/img/es.png"];
    const handleFlagChange = () => {
        playSoundById("ButtonClickMp3");
        const nextIndex = (currentFlagIndex + 1) % flagImg.length;
        setCurrentFlagIndex(nextIndex);
    };

    const getFooterInfoSettingSection = () => {
        return <div className="d-flex footer-halloween align-items-center justify-content-center w-100">
            <div className="halloween-inner w-100">
                <div className="row">
                    <div className="col-3">
                        <div className="d-flex align-items-center ">
                            <div
                                className={`cursor-pointer d-flex align-items-center justify-content-center me-2 ${(slotRunning) ? "btn-gray-q text-black" : "btn-blue text-white"}`}
                                onClick={() => {
                                    if (!slotRunning) {
                                        playSoundById("ButtonClickMp3");
                                        setShowHelpModel(true);
                                    }
                                }}><i className="fa fa-question fw-bolder" aria-hidden="true"></i>
                            </div>
                            <div className="cursor-pointer btn-blue text-white d-flex align-items-center justify-content-center me-2"
                                onClick={() => {
                                    setNextSoundLevelOfAudio();
                                }}>
                                {/* <i className="fa fa-volume-up fw-bolder" aria-hidden="true"></i> */}
                                <img id="audioVolume" src={"/assets/img/sound/sound-1.00.png"} style={{
                                    height: "20px",
                                    width: "100%"
                                }} />
                            </div>
                            <div className="position-relative" disabled={jogarButtonFlag || buttonFlag}>
                                <div onClick={toggleAutoButtonModel} className="auto-btn d-flex align-items-center cursor-pointer" disabled={jogarButtonFlag || buttonFlag}>
                                    <div className="auto-inner text-white d-flex align-items-center justify-content-center" >AUTO</div>
                                    <div className="d-flex align-items-center">
                                        <span className="auto-green"></span>
                                        <p className="m-0 text-white fs-6">{autoCount > -1 ? autoCount : "∞"}</p>
                                    </div>
                                </div>
                                {getAutoButtonModel()}
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="d-flex align-items-center justify-content-between details-footer w-100">
                            <p className="text-white m-0">BALANCE:
                                {/* {getFormattedAmount(walletBalance)} */}
                                {" "} {getFormattedAmountWithDenominationGamePlayBy100(walletBalance, denomination)}
                            </p>
                            <p className="text-white m-0">APOSTA:   {formatAmount(betMultiplier * selectedNumber)}</p>
                            <p className="text-white m-0">PAGO: {getFormattedAmountN(winnings * denomination)}</p>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="d-flex align-items-center justify-content-end">
                            <div className="position-relative">
                                <div onClick={toggleSettingModel} className="cursor-pointer btn-blue text-white d-flex align-items-center justify-content-center me-2">
                                    <i className="fa fa-cog fw-bolder" aria-hidden="true"></i>
                                </div>
                                {showSettingModel && (
                                    <div className="bottom-right-div">
                                        <div className="w-100 d-flex align-items-center justify-content-center turn-btn">QUALIDADE</div>
                                        <div className="d-block">
                                            <button className="mb-1 mt-2 text-center custom-button">MAXIMA</button>
                                            <button className="mb-1 text-center custom-button">MEDIA</button>
                                            <button className="mb-0 text-center custom-button">MINIMA</button>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="cursor-pointer flag-btn" onClick={handleFlagChange}>
                                <img src={flagImg[currentFlagIndex]} className="img-fluid" alt="flag" style={{ height: "23px", width: "33px" }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    const getHelpModel = () => {
        return <ModalHalloween show={showHelpModel} toggleModel={() => setShowHelpModel(false)}>
            <div className="modal-dialog modal-fullscreen">
                <div className="modal-content" style={{ background: "#0a0f29" }}>
                    <div className="modal-header position-relative">
                        <h6 className="m-0">Prize Table</h6>
                    </div>
                    <div className="modal-body text-center p-0 bg-help">
                        <div className="h-100">
                            <Swiper onSwiper={(swiper) => setHelpSwiperInstance(swiper)} navigation={false} loop={false} className="mySwiper">
                                {ruleImagesArray.map((rule, i) => (
                                    <SwiperSlide key={i}>
                                        <img src={rule} alt={`rules-${i}`} className="img-fluid w-100 h-100" />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                            <div className="position-absolute back-btn">
                                <button id="prev-btn" className="slick-arrow slick-prev" onClick={() => handlePreviousHelpSlide()}
                                    style={{ color: "white", position: "unset", transform: "none", opacity: currentIndexOfHelpSlide === 0 ? 0.5 : 1 }}>Prev</button>
                                <button className="btn-grey text-center" onClick={() => {
                                    playSoundById("ButtonClickMp3");
                                    setShowHelpModel(false);
                                }}>Back</button>
                                <button id="next-btn" className="slick-arrow slick-next" onClick={() => handleNextHelpSlide()}
                                    style={{ color: "white", position: "unset", transform: "none", opacity: currentIndexOfHelpSlide === ruleImagesArray.length - 1 ? 0.6 : 1 }}>Next</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ModalHalloween>;
    }

    // Common list of static resources
    const staticResources = {
        // Main character images
        characters: [
            "assets/img/diabo.png",
            "assets/img/vampire.png",
            "assets/img/fantasma.png",
            "assets/img/espanthalho.png",
            "assets/img/abobora.png",
            "assets/img/frankenstein.png",
            "assets/img/calderao.png",
            "assets/img/bruxa.png",
            "assets/img/bruxinha.png",
            "assets/img/magica.png"
        ],

        // Slider images
        sliderImages: Array.from({ length: 10 }, (_, i) => `assets/img/sliderImage/${i}.jpg`),

        // Sound control images
        soundImages: [
            "/assets/img/sound/sound-0.00.png",
            "/assets/img/sound/sound-0.25.png",
            "/assets/img/sound/sound-0.50.png",
            "/assets/img/sound/sound-0.75.png",
            "/assets/img/sound/sound-1.00.png"
        ],

        // Strawberries bonus images
        strawberriesImages: [
            "/assets/img/strawberries/anim-abrindo.gif",
            "/assets/img/strawberries/anim-girando.gif",
            "/assets/img/strawberries/bg.png",
            "/assets/img/strawberries/fim-do-bonus.gif"
        ],

        // Roulette bonus images
        rouletteImages: [
            "/assets/img/Roulette/bg.png",
            "/assets/img/Roulette/header-bar.png",
            "/assets/img/Roulette/score-btn.png",
            "/assets/img/Roulette/seta.png",
            "/assets/img/Roulette/wheel.png"
        ],

        // GiraLuz bonus images
        giraLuzImages: [
            "/assets/img/GiraLuz/gamePlay-img.png"
        ],

        // PoolSpin bonus images
        poolSpinImages: [
            "/assets/img/poolSpin/bol0.png",
            "/assets/img/poolSpin/bol1.png",
            "/assets/img/poolSpin/bol2.png",
            "/assets/img/poolSpin/bol3.png",
            "/assets/img/poolSpin/bol4.png",
            "/assets/img/poolSpin/bol5.png",
            "/assets/img/poolSpin/bol6.png",
            "/assets/img/poolSpin/bol7.png",
            "/assets/img/poolSpin/bol8.png",
            "/assets/img/poolSpin/bol9.png",
            "/assets/img/poolSpin/jogador.gif",
            "/assets/img/poolSpin/mesa.gif",
            "/assets/img/poolSpin/roll.gif",
            "/assets/img/poolSpin/taco.gif",
            "/assets/img/poolSpin/triangulo.gif",
            "/assets/img/poolSpin/sec-bottom.png",
            "/assets/img/poolSpin/sec-middle.png",
            "/assets/img/poolSpin/sec-top.png"
        ],

        // Pumpkin bonus images
        pumpkinImages: [
            "/assets/img/pumpkin/anim-pumpkin.gif",
            "/assets/img/pumpkin/anim-witch.gif",
            "/assets/img/pumpkin/bg.png",
            "/assets/img/pumpkin/box-bg.png"
        ],

        // Cauldron bonus images
        cauldronImages: [
            "/assets/img/cauldron/anim-idle.gif",
            "/assets/img/cauldron/anim-idle-0.gif",
            "/assets/img/cauldron/anim-idle-1.gif",
            "/assets/img/cauldron/anim-idle-2.gif",
            "/assets/img/cauldron/anim-idle-3.gif",
            "/assets/img/cauldron/anim-idle-4.gif",
            "/assets/img/cauldron/anim-selected.gif",
            "/assets/img/cauldron/anim-selected.jpg",
            "/assets/img/cauldron/btn-bg.png",
            "/assets/img/cauldron/bg.jpg",
            "/assets/img/cauldron/caldeirao.gif",
            "/assets/img/cauldron/caldeirao-abobora-bonus.png",
            "/assets/img/cauldron/caldeirao-abobora-frase.png",
            "/assets/img/cauldron/caldeirao-abobora-multiplique.png",
            "/assets/img/cauldron/caldeirao-bonus.png",
            "/assets/img/cauldron/caldeirao-frase.png",
            "/assets/img/cauldron/caldeirao-multiplique.png",
            "/assets/img/cauldron/footer-logo.png",
            "/assets/img/cauldron/header-logo.png",
            "/assets/img/cauldron/premioBonusAbobora.png",
            "/assets/img/cauldron/text1.png",
            "/assets/img/cauldron/text2.png",
            "/assets/img/cauldron/text3.png"
        ],

        // Dice bonus images
        diceImages: [
            "/assets/img/DIceBonus/bg.png",
            "/assets/img/DIceBonus/header-bar.png",
            "/assets/img/DIceBonus/score-btn.png",
            "/assets/img/DIceBonus/dice.gif",
            "/assets/img/DIceBonus/dice-1.png",
            "/assets/img/DIceBonus/dice-2.png",
            "/assets/img/DIceBonus/dice-3.png",
            "/assets/img/DIceBonus/dice-4.png",
            "/assets/img/DIceBonus/dice-5.png",
            "/assets/img/DIceBonus/dice-6.png"
        ],

        // Audio files
        audioFiles: [
            { id: "SlotMp3", src: "assets/slot.mp3" },
            { id: "Win45Wav", src: "assets/win45.wav" },
            { id: "AwardWav", src: "assets/bomba-premio.mp3" },
            { id: "ButtonClickMp3", src: "assets/standardClick.mp3" },
            { id: "ErrorMp3", src: "assets/error.mp3" },
            { id: "CreditsCounterMp3", src: "assets/sound_fx_creditsCounterLoop.mp3" }
        ],

        // Dynamic dice bonus images (0-79)
        dynamicDiceImages: Array.from({ length: 80 }, (_, i) => `assets/img/DIceBonus/(${i}).webp`)
    };

    const loadStaticResources = () => {
        return <>
            <div style={{ display: "none" }}>
                {/* Character images */}
                {staticResources.characters.map((src, index) => (
                    <img key={`char-${index}`} className="img-fluid" src={src} alt="" />
                ))}

                {/* Slider images */}
                {staticResources.sliderImages.map((src, index) => (
                    <img key={`slider-${index}`} src={src} alt="" />
                ))}

                {/* Sound control images */}
                {staticResources.soundImages.map((src, index) => (
                    <img key={`sound-${index}`} src={src} alt="" />
                ))}

                {/* Strawberries bonus images */}
                {staticResources.strawberriesImages.map((src, index) => (
                    <img key={`strawberry-${index}`} src={src} alt="" />
                ))}

                {/* Roulette bonus images */}
                {staticResources.rouletteImages.map((src, index) => (
                    <img key={`roulette-${index}`} src={src} alt="" />
                ))}

                {/* GiraLuz bonus images */}
                {staticResources.giraLuzImages.map((src, index) => (
                    <img key={`giraLuz-${index}`} src={src} alt="" />
                ))}

                {/* PoolSpin bonus images */}
                {staticResources.poolSpinImages.map((src, index) => (
                    <img key={`poolSpin-${index}`} src={src} alt="" />
                ))}

                {/* Pumpkin bonus images */}
                {staticResources.pumpkinImages.map((src, index) => (
                    <img key={`pumpkin-${index}`} src={src} alt="" />
                ))}

                {/* Cauldron bonus images */}
                {staticResources.cauldronImages.map((src, index) => (
                    <img key={`cauldron-${index}`} src={src} alt="" />
                ))}

                {/* Dice bonus images */}
                {staticResources.diceImages.map((src, index) => (
                    <img key={`dice-${index}`} src={src} alt="" />
                ))}

                {/* Audio files */}
                {staticResources.audioFiles.map((audio, index) => (
                    <audio key={`audio-${index}`} controls="" id={audio.id} className="audioFile">
                        <source src={audio.src} type="audio/mpeg" />
                    </audio>
                ))}

                {/* Dynamic dice bonus images */}
                {staticResources.dynamicDiceImages.map((src, index) => (
                    <img key={`dynamicDice-${index}`} src={src} alt="" />
                ))}
            </div>
        </>
    }

    const onBonusRoundCompleted = (pTotalBonus) => {
        setShowBonusModel(false);
        if (pTotalBonus > 0) {
            let ptotalGameBonus = pTotalBonus;
            setWinnings(ptotalGameBonus);

            if (accumuladoWin.winAmount > 0) {
                setShowCoins(true)
                setTimeout(() => {
                    setShowCoins(false)
                    animateAccumuladoWinning(walletBalance, accumuladoWin.winAmount, accumuladoWin.winIndex);
                    playWinningAnimation(walletBalance, ptotalGameBonus, accumuladoWin.winAmount);
                }, 25000)
            }
            else {
                playWinningAnimation(walletBalance, ptotalGameBonus, accumuladoWin.winAmount);
            }
            let countTime = 5000;
            if (accumuladoWin.winAmount > 0) {
                countTime = 38000;
            }

            if (autoBetOn) {
                var pAutoBetTimeOutRef = setTimeout(() => {
                    setAutoCount(prevCount => {
                        if (prevCount > 0) {
                            return prevCount - 1;
                        } else if (prevCount === 0) {
                            return 0;
                        } else {
                            return -1;
                        }
                    });
                    setPlayMachine(pCounter => pCounter + 1);
                }, countTime);
                setAutoBetTimeOutRef(pAutoBetTimeOutRef);
            }

        }
    };


    const bonusModel = () => {
        if (gameResult === null || isEmpty(gameResult.bonusType) || gameResult.bonusType === "None") {
            return <></>;
        }
        const renderBonusContent = () => {
            switch (gameResult.bonusType) {
                case "Bonus01Strawberry":
                    return (
                        <Bonus01Strawberry
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            walletBalance={walletBalance}
                            denomination={denomination}
                            keyboardInput={keyboardInput}
                        />
                    );
                case "Bonus02Roulette":
                    return (
                        <RouletteBonus
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            gameResult={gameResult}
                            keyboardInput={keyboardInput}
                        />
                    );
                case "Bonus03ACauldron":
                    return (
                        <CauldronBonus
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            walletBalance={walletBalance}
                            denomination={denomination}
                            gameResult={gameResult}
                            keyboardInput={keyboardInput}
                        />
                    );
                case "Bonus04Dice":
                    return (
                        <DiceBonus
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            gameResult={gameResult}
                            keyboardInput={keyboardInput}
                        />
                    );
                case "Bonus05LittleWitchPumpkinPulling":
                    return (
                        <PumpkinBonus
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            walletBalance={walletBalance}
                            denomination={denomination}
                            gameResult={gameResult}
                        />
                    );
                case "Bonus06PoolSpinsLightWitch":
                    return (
                        <PoolSpinBonus
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            walletBalance={walletBalance}
                            denomination={denomination}
                            gameResult={gameResult}
                            keyboardInput={keyboardInput}
                        />

                    );
                case "Bonus07GiraLuz":
                    return (
                        <GiraLuzBonus
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            walletBalance={walletBalance}
                            denomination={denomination}
                            gameResult={gameResult}
                            keyboardInput={keyboardInput}
                        />
                    );
                default:
                    return null;
            }
        };
        return <>
            <ModalHalloween show={showBonusModel} toggleModel={() => { }}>
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content" style={{ background: "#0a0f29" }}>
                        <div className="modal-body text-center p-0 bg-help">
                            <div className="h-100">
                                {/* {
                                    gameResult.bonusType === "Bonus01Strawberry" &&
                                    <Bonus01Strawberry gameSessionRecordId={gameResult.recordId}
                                        onBonusRoundCompleted={onBonusRoundCompleted} walletBalance={walletBalance} denomination={denomination} />
                                } */}
                                {renderBonusContent()}
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHalloween>
        </>
    }

    return (
        <>
            {showCoins && <CoinContainer />}
            {/* Bomba header start------------------------------------------------------------------------ */}
            <div className="">
                <div className="row">
                    <div className="col-6 pe-0">
                        <div className="d-flex h-100 ">
                            <div className="col-10 p-0 position-relative">
                                <img className="w-100 h-100" src="assets/img/bomba-table-img.png" alt="" />
                                <div className="table-content">
                                    <div className="left-side">89</div>
                                    <div className="right-side">
                                        <div className="h-100 top-table">
                                            <ul>
                                                <li>7</li>
                                                <li>83</li>
                                                <li>88</li>
                                                <li>64</li>
                                                <li>3</li>
                                                <li>4</li>
                                                <li>3333333</li>
                                            </ul>
                                        </div>
                                        <div className="h-100 bottom-div">BONUS SENA</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-2 ps-0">
                                <div className="fs-1-5 h-100 d-flex flex-column align-center text-center text-white justify-content-end">
                                    <div>PAGO:</div>
                                    <span>0</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="row">
                            <div className="col-10">
                                <div className="d-flex gap-2">
                                    <div className="w-100 text-center">
                                        <img src="assets/img/credit.png" alt="credit" className="img-fluid header-mb" />
                                        <div className="btn-custom d-flex align-items-center justify-content-center w-100">
                                            <span className="btn-custom-outer w-100">
                                                <span className="btn-custom-inner d-flex align-items-center justify-content-center text-white w-100">0</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="w-100 text-center">
                                        <img src="assets/img/credit.png" alt="credit" className="img-fluid header-mb" />
                                        <div className="btn-custom d-flex align-items-center justify-content-center w-100">
                                            <span className="btn-custom-outer w-100">
                                                <span className="btn-custom-inner d-flex align-items-center justify-content-center text-white w-100">0</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-3 p-0 text-center">
                                        <img src="assets/img/bet.png" alt="credit" className="img-fluid header-mb" />
                                        <div className="btn-custom d-flex align-items-center justify-content-center w-100">
                                            <span className="btn-custom-outer w-100">
                                                <span className="btn-custom-inner d-flex align-items-center justify-content-center text-white w-100">0</span>
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-2 p-0">
                                <div className="text-center position-relative">
                                    <img src="assets/img/no-img.png" alt="credit" className="img-fluid header-mb mx-auto" />
                                    <span className="position-absolute top-0 start-0 end-0 bottom-0 Bomba-no">25</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Bomba header end------------------------------------------------------------------------ */}

            {/* halloween header start------------------------------------------------------------------------ */}
            {/* <div className="d-flex align-items-center pc-header">
                <div className="credit-value-box d-flex align-items-center justify-content-center me-lg-5 me-md-4 me-sm-3 me-2">{denomination}</div>
                {pagoWinningCounter && (
                    <div className="win-text">
                        Pago: <span className="text-white">{pagoWinningCounter}</span>
                    </div>
                )}
                <div className="row w-100">
                    <div className="col-4">
                        <div className="d-flex align-items-center">
                            <img src="assets/img/credit.png" alt="credit" className="img-fluid me-2 header-mb w-100" />
                            <div className="btn-custom d-flex align-items-center justify-content-center w-100">
                                <span className="btn-custom-outer w-100">
                                    <span className="btn-custom-inner d-flex align-items-center justify-content-center text-white w-100">
                                        {getFormattedAmountWithDenomination(walletBalance, denomination)}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="d-flex align-items-center">
                            <img src="assets/img/award.png" alt="award" className="img-fluid me-2 header-mb w-100" />
                            <div className="btn-custom d-flex align-items-center justify-content-center w-100">
                                <span className="btn-custom-outer w-100">
                                    <span className={`btn-custom-inner d-flex align-items-center justify-content-center text-white w-100`}>
                                        {winnings}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="d-flex align-items-center">
                            <div className="w-100 position-relative ">
                                <img src="assets/img/bet.png" alt="bet" className="img-fluid me-2 header-mb w-100" />
                                <div className="aposDiv">
                                    <div className=" d-flex align-items-center justify-content-center position-relative ">
                                        <img src="assets/img/VectorImg.png" alt="award" className="w-100" />
                                        <span className="aposValue">
                                            {getFormattedAmountWithDenomination(betMultiplier, denomination)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="btn-custom d-flex align-items-center justify-content-center w-100">
                                <span className="btn-custom-outer w-100">
                                    <span className="btn-custom-inner d-flex align-items-center justify-content-center text-white w-100">
                                        {getFormattedAmountWithDenomination(betMultiplier, denomination) * selectedNumber}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* halloween header end------------------------------------------------------------------------ */}
            <div className="main-content">
                <div className="w-100 h-100 d-flex flex-column ">
                    <div className={`game-container ${(templateNumber === 25 || templateNumber === 30) && "cPb"}`}>
                        {autoBetOn && <div className="AutoText"> JOGA AUTOMATICO</div>}
                        <HalloweenMachine ref={machineRef} gameResult={gameResult} animateColumn={animateColumn} stopMachineFlag={stopMachineFlag} />
                        <LineImages templateData={templateData} templateNumber={templateNumber} activeLine={activeLineNumber} />
                        <NumberLineImages templateData={templateData} templateNumber={templateNumber} activeLine={activeLineNumber} />
                        {showInsufficientFundModel && (
                            <div className="balance-popup text-white">
                                <div className="content">
                                    <p className="mb-0">Insira Creditos</p>
                                </div>
                            </div>
                        )}
                        {resetAmntModel && (
                            <div className="resetBalance-popup text-white">
                                <div className="content">
                                    <div className="ser-no-text">N.SEC. 001</div>
                                    <div style={{ margin: "30px 0" }}>
                                        <p className="mb-0">FAVOR CHAMAR 0 OPERADOR</p>
                                        <p className="mb-4">PARA RECEBER SEUS CREDITOS</p>
                                        <p className="mb-0">CREDITOS: {getFormattedAmountWithDenomination(walletBalance, denomination)}</p>
                                        <p className="mb-4">{formatAmount(walletBalance)}</p>
                                    </div>
                                    <div className="ser-no-text">VALIDACAO : 538978871</div>
                                </div>
                            </div>
                        )}
                    </div>
                    {getBottomPrizeSection()}
                </div>
            </div>
            <div className="footer">
                {/* {getFooterLineButtonSection()}
                {getFooterInfoSettingSection()} */}
                {getFooterBombaLineButtonSection()}
            </div>
            {getHelpModel()}
            {loadStaticResources()}
            {bonusModel()}
            <ModalHalloween show={showAjudaModel} toggleModel={() => { }}>
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content" style={{ background: "#0a0f29" }}>
                        <div className="modal-body text-center p-0 bg-help">
                            <div className="h-100">
                                <img onClick={() => { setShowBonusBombaModel(true); }} className="w-100 h-100" src="assets/img/tabela-img.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHalloween>
            <ModalHalloween show={showBonusBombaModel} toggleModel={() => { }}>
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content" style={{ background: "transparent" }}>
                        <div className="modal-body text-center p-0" style={{ background: "transparent" }}>
                            <div className="h-100">
                                <img onClick={() => { setShowBonusBombaModel(false); setShowAjudaModel(false) }} className="w-100 h-100" src="assets/img/bonus-bomba-img.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHalloween>
            {/* <ModalHalloween show={true} toggleModel={() => { }}>
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content" style={{ background: "transparent" }}>
                        <div className="modal-body text-center p-0" style={{ background: "transparent" }}>
                            <div className="h-100">
                                <BombaBunus />
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHalloween> */}
            <ModalHalloween show={true} toggleModel={() => { }}>
                <div className="modal-dialog h-100 d-flex justify-content-between align-items-center " style={{ maxWidth: "1000px" }}>
                    <div className="modal-content" style={{ background: "transparent" }}>
                        <div className="modal-body text-center p-0" style={{ background: "transparent" }}>
                            <div className="h-100">
                                <BonusMaior />
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHalloween>
            {/* <ModalHalloween show={true} toggleModel={() => { }}>
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content" style={{ background: "transparent" }}>
                        <div className="modal-body text-center p-0" style={{ background: "transparent" }}>
                            <div className="h-100 d-flex align-items-center justify-content-center">
                                <img src="assets/img/bomba/telarg.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHalloween> */}
            {/* <ModalHalloween show={true} toggleModel={() => { }}>
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content" style={{ background: "transparent" }}>
                        <div className="modal-body text-center p-0" style={{ background: "transparent" }}>
                            <div className="h-100">
                                <BombaStrawberries />
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHalloween> */}
        </>
    );
};

export default GamePlayBomba;